import { render, staticRenderFns } from "./StarterInput.vue?vue&type=template&id=081181e0&scoped=true&"
import script from "./StarterInput.vue?vue&type=script&lang=ts&"
export * from "./StarterInput.vue?vue&type=script&lang=ts&"
import style0 from "./StarterInput.vue?vue&type=style&index=0&id=081181e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081181e0",
  null
  
)

export default component.exports